import { ReactElement, useEffect, useState } from 'react'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'
import { MobileStartScreen } from './MobileStartScreen'
import { WebStartScreen } from './WebStartScreen'
import { NextEventData, useNextEventStore } from '../../stores/NextEventStore'
import { SpinnerWrapper } from '../../components/spinner/SpinnerWrapper'
import { HelmetProvider } from 'react-helmet-async'

export const StartScreen = (): ReactElement => {
  const isMobile = useMatchMedia(`(max-width:${pageBreakpoints.md})`)
  const nextEventStore = useNextEventStore()
  const [bannerData, setBannerData] = useState<NextEventData[]>()

  useEffect(() => {
    if (nextEventStore.loaded) {
      setBannerData(nextEventStore.nextEventData)
    }
  }, [nextEventStore])

  const firstEvent = bannerData?.[0]

  return (
    <>
      {firstEvent && (
        <HelmetProvider>
          <title>{firstEvent.eventName}</title>
          <meta
            name='description'
            content={`Besuche ${firstEvent.eventName} am ${firstEvent.eventDatum}`}
          />

          {/* Open Graph */}
          <meta property='og:title' content={firstEvent.eventName} />
          <meta
            property='og:description'
            content={`Erlebe ${firstEvent.eventName} am ${firstEvent.eventDatum} in ${firstEvent.eventHalle}`}
          />
          <meta property='og:image' content={firstEvent.eventHintergrund || firstEvent.eventLogo} />
          <meta property='og:url' content={`https://fightback-wrestling.com/`} />
          <meta property='og:type' content='website' />

          {/* Twitter Card */}
          <meta name='twitter:card' content='summary_large_image' />
          <meta name='twitter:title' content={firstEvent.eventName} />
          <meta name='twitter:description' content={`Datum: ${firstEvent.eventDatum}`} />
          <meta
            name='twitter:image'
            content={firstEvent.eventHintergrund || firstEvent.eventLogo}
          />
        </HelmetProvider>
      )}

      <SpinnerWrapper loaded={nextEventStore.loaded} isMobile={isMobile}>
        {bannerData === undefined ? (
          <></>
        ) : isMobile ? (
          <MobileStartScreen data={bannerData} />
        ) : (
          <WebStartScreen data={bannerData} />
        )}
      </SpinnerWrapper>
    </>
  )
}
